<template>
  <div class="form_step form_step-4 form-scroll">
    <div class="wrapper">
      <div class="wrapper__step-header">
        <button type="button" 
                @click.submit.prevent="goBack"
                class="popup-button btn green-btn colored-btn">
          {{__t('Повернутись назад')}}
        </button>
        <form-header :load="'67%'"></form-header>
      </div>

      <type_activity_1
        v-if="type_activity == 1 || type_activity == 3"
        :months="months"
        :positions="positions"
        :employerownership="employerownership"
        :regions="regions"
        :type_activity="type_activity"
        :activities="activities"
        @gonext="goNext()"
        @goback="goBack()"
        @closePreloader="closePreloader"
        @openPreloader="openPreloader"
        @error="$emit('error')"
        @success="$emit('success')"
        @call="$emit('call')"
        @returnbegin="$emit('returnbegin')"
      ></type_activity_1>
      <type_activity_2
              v-if="type_activity == 2"
              @gonext="goNext()"
              @goback="goBack()"
              @closePreloader="closePreloader"
              @openPreloader="openPreloader"
              @error="$emit('error')"
              @success="$emit('success')"
              @call="$emit('call')"
              @returnbegin="$emit('returnbegin')"
      ></type_activity_2> <!-- пенсионер -->
      <type_activity_4
              v-if="type_activity == 4"
              @gonext="goNext()"
              @goback="goBack()"
              @closePreloader="closePreloader"
              @openPreloader="openPreloader"
              :taxsystem="taxsystem"
              :activitieskind="activitieskind"
              :periodforfop3="periodforfop3"
              :quarterperiod="quarterperiod"
              @error="$emit('error')"
              @success="$emit('success')"
              @call="$emit('call')"
              @returnbegin="$emit('returnbegin')"
      ></type_activity_4>

    </div>
  </div>
</template>

<script>
    import type_activity_1 from './type_activity_1'
    import type_activity_2 from './type_activity_2'
    import type_activity_4 from './type_activity_4'

    export default {
        name: "step4",
        components: {
            type_activity_1,
            type_activity_2,
            type_activity_4,
        },
        props: [
            'typesubjects',
            'type_activity',
            'positions',
            'employerownership',
            'regions',
            'activities',
            'taxsystem',
            'activitieskind',
            'periodforfop3',
            'quarterperiod'
        ],
        data() {
            return {
                changeWork: "false",
                months: [
                    "Січень",
                    "Лютий",
                    "Березень",
                    "Квітень",
                    "Травень",
                    "Червень",
                    "Липень",
                    "Серпень",
                    "Вересень",
                    "Жовтень",
                    "Листопад",
                    "Грудень"
                ],
            }
        },

        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            goNext() {
                this.$emit('gonext');
                return false;
            },
            goBack() {
                if( this.type_activity == 11){
                    this.$emit('goback');
                    this.$emit('goback');
                }else{
                    this.$emit('goback');
                }

                return false;
            },
            openPreloader(){
                this.$emit('openPreloader');
            },
            closePreloader(){
                this.$emit('closePreloader');
            }
        },

       
    }
</script>
